/**
 * A client phone, click-to-call: a tel: link (E.164) showing the number exactly
 * as phoneOrDash formats it (href from telHref, which the portals use too).
 * Used in the lead file header only — list rows, Follow-Ups and Dispatch show
 * phones as plain text. The click does not propagate, so it is safe inside a
 * clickable container. No phone on file is a plain dash.
 *
 * With the RingCentral phone on (VITE_RINGCENTRAL_CLIENT_ID, desktop only) and
 * a leadId given, the click dials through the docked widget instead
 * (lib/ringcentral startCall); on mobile it opens the RingCentral app
 * (callWithRingCentralApp, the company number); otherwise the OS / the
 * browser's tel: handler places the call.
 */

import React from 'react';
import { phoneOrDash, telHref } from '../lib/format';
import { ringCentralPhoneEnabled, ringCentralAppCalls, startCall, callWithRingCentralApp } from '../lib/ringcentral';

export function PhoneLink({ phone, style, leadId }: { phone: unknown; style?: React.CSSProperties; leadId?: string }) {
  const text = phoneOrDash(phone);
  const href = String(phone ?? '').trim() ? telHref(phone) : null;
  if (!href) return <span style={style}>{text}</span>;
  return (
    <a
      href={href}
      onClick={(e) => {
        e.stopPropagation();
        if (ringCentralPhoneEnabled && leadId) { e.preventDefault(); startCall(phone, leadId); }
        else if (ringCentralAppCalls && leadId) { e.preventDefault(); callWithRingCentralApp(phone); }
      }}
      title={`Call ${text}`}
      style={{ color: 'inherit', textDecoration: 'none', cursor: 'pointer', ...style }}
      onMouseEnter={(e) => { e.currentTarget.style.textDecoration = 'underline'; }}
      onMouseLeave={(e) => { e.currentTarget.style.textDecoration = 'none'; }}
    >
      {text}
    </a>
  );
}
